// extracted by mini-css-extract-plugin
export var dateby = "topper-module--dateby--frZoJ";
export var dek = "topper-module--dek--6fR-t";
export var figure = "topper-module--figure--ZzMX9";
export var header = "topper-module--header--3jsFQ";
export var hed = "topper-module--hed--kcsDF";
export var image = "topper-module--image--MTLLF";
export var kicker = "topper-module--kicker--YHIWC";
export var socialIcon = "topper-module--socialIcon--HDp4c";
export var textContainer = "topper-module--text-container--YZnr7";
export var topcap = "topper-module--topcap--N3k-5";
export var topcred = "topper-module--topcred--sE05c";
export var topsocial = "topper-module--topsocial--srX1R";